import jwt_decode from "jwt-decode";
import * as Cookies from "./cookies";

export const emptyUser = {
  is_leagues_manager: false,
  refereed_league_ids: [],
  player: {
    phone_number: "",
    sentence: "",
    team: 0,
    city: 0,
    school: "",
    grade: 0,
    status: "",
    profile_pic: "",
    shirt_size: "",
    token: "",
    goals_count: 0,
    assists_count: 0,
  },
  id: 0,
  phone_number: "",
  first_name: "",
  last_name: "",
  full_name: "",
};

export const isPlayerStatus = (status, user) => {
  if (user) {
    if (status === "rakaz") {
      return user.is_leagues_manager;
    } else {
      if (user.player !== undefined && user.player !== null) {
        return status === user.player.status;
      } else {
        return false;
      }
    }
  }
};

export async function getUserInfoFromToken() {
  const token = Cookies.getToken();
  const decoded = jwt_decode(token);

  if (decoded.user_id) {
    return decoded.user_id;
  } else {
    return null;
  }
}






export const validUserIsPlayer = (user, playerId) => {
  return user.id == parseInt(playerId);
};


export const validNoTeamUser = (user) => user.player.team !== null;


export const validUserInTeam = (user, team_pk) => {
  if (user.is_leagues_manager === true || user.player === null) {
    return false;
  }
  return user.player.team !== null && user.player.team === parseInt(team_pk);
};


export const validCaptainTeam = (user, team_pk) => {
  if (user.is_leagues_manager === true || user.player === null) {
    return false;
  }
  return (
    user.player.team === parseInt(team_pk) && user.player.status === "captain"
  );
};


export const validRakazLeague = (user) => user.is_leagues_manager === true;

export const validRefereeLeague = (user, leagueId) =>
  user?.refereed_league_ids?.includes(parseInt(leagueId)) === true;

export const canReportMatch = (user, leagueId) =>
  validRakazLeague(user) || validRefereeLeague(user, leagueId);






export const validToGroupMembersOnPlayer = (user, team_pk, playerId) =>
  validUserIsPlayer(user, playerId) ||
  validCaptainTeam(user, team_pk) ||
  validRakazLeague(user);


export const validToGroupMembers = (user, team_pk) =>
  validUserInTeam(user, team_pk) ||
  validCaptainTeam(user, team_pk) ||
  validRakazLeague(user);

export const validGroupMasters = (user, team_pk) =>
  validCaptainTeam(user, team_pk) || validRakazLeague(user);

export const validToEditPlayer = (user, playerId) =>
  validUserIsPlayer(user, playerId) || validRakazLeague(user);

export const validSeeGroupCTAbtn = (user, team_pk) =>
  isPlayerStatus("no_team", user) || validToGroupMembers(user, team_pk);



export const deviceIsIphone = () => {
  const platform = navigator.platform;
  const isIphone = [
    "iPhone Simulator",
    "iPhone",
    "Win16",
    "Win32",
    "WinCE",
    "Mac68K",
    "MacPPC",
    "MacIntel",
    "Linux i686",
    "Linux armv7l",
  ].includes(platform);
  return isIphone;
};


export function getCurrentDate() {
  const date = new Date();

  const [year, month, day] = [
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
  ];

  const resMonth = month < 10 ? `0${month}` : `${month}`;
  const resDays = day < 10 ? `0${day}` : `${day}`;

  return `${year}-${resMonth}-${resDays}`;
}

export function showDate(myDate) {
  const days = myDate.slice(8);
  const month = myDate.slice(5, 7);
  const year = myDate.slice(0, 4);

  return `${days.lenght === 1 ? "0" + days : days}/${month}/${year}`;
}

export function showHourMinutes(myDate) {
  return myDate.slice(11, 16);
}

export function getRound(roundId, rounds) {
  const res = rounds.filter((round) => round.id === parseInt(roundId, 10))[0];
  return res;
}

export function makeDateFromTime(myDate, myTime) {
   const dateAsTimedate = new Date(myDate);
   const hh = parseInt(myTime.slice(0, 2), 10);
  const mm = parseInt(myTime.slice(3), 10);
  dateAsTimedate.setHours(hh, mm);
  return dateAsTimedate;
}

export function reFormatMatchData(match) {
  const team1_id = match.teams[0].id;
  const team2_id = match.teams[1].id;
  const team1info = match.teams.filter((team) => team.id === team1_id)[0];
  const team2info = match.teams.filter((team) => team.id === team2_id)[0];
  const team1match = match.match_results.filter(
    (team) => team.team_id === team1_id
  )[0];
  const team2match = match.match_results.filter(
    (team) => team.team_id === team2_id
  )[0];

  const newMatch = {
    court: match.court,
    court_name: match.court_name,
    id: match.id,
    is_finished: match.is_finished,
    goals_list: match.goals_list,
    round: match.round,
    start_time: match.start_time,
    teams: [
      {
        captain: team1info.captain,
        captain_name: team1info.captain_name,
        id: team1info.id,
        image: team1info.image,
        is_active: team1info.is_active,
        league: team1info.league,
        name: team1info.name,
        slogan: team1info.slogan,
        goals: team1match.goals,
        green_cards: team1match.green_cards,
        points: team1match.points,
        state: team1match.state,
      },
      {
        captain: team2info.captain,
        captain_name: team2info.captain_name,
        id: team2info.id,
        image: team2info.image,
        is_active: team2info.is_active,
        league: team2info.league,
        name: team2info.name,
        slogan: team2info.slogan,
        goals: team2match.goals,
        green_cards: team2match.green_cards,
        points: team2match.points,
        state: team2match.state,
      },
    ],
  };

  return newMatch;
}

export const userToPlayer = (user) => {
  return {
    phone_number: user.player.phone_number,
    sentence: user.player.sentence,
    team: user.player.team,
    city: user.player.city,
    school: user.player.school,
    grade: user.player.grade,
    status: user.player.status,
    profile_pic: user.player.profile_pic,
    shirt_size: user.player.shirt_size,
    goals_count: user.player.goals_count,
    assists_count: user.player.assists_count,
    user_id: user.id,
    user: {
      id: user.id,
      phone_number: user.phone_number,
      first_name: user.first_name,
      last_name: user.last_name,
      full_name: user.full_name,
    },
  };
};

export const datesDistance = (stringDate, date) => {
  const yy = parseInt(stringDate.slice(0, 4), 10);
  const mm = parseInt(stringDate.slice(5, 7), 10);
  const dd = parseInt(stringDate.slice(8, 10), 10);
  const newDate = new Date(yy, mm - 1, dd, 0, 0, 0);

  return Math.abs((newDate - date) / 1000 / 60 / 60 / 24);
};









